export enum EVas {
  Auction = 'auction',
  Colorized = 'colorized',
  Top = 'top3',
  Premium = 'premium',
  Paid = 'paid',
}

export interface IVas {
  type: EVas;
  name: string;
  description: string;
}
